<template>
  <div>
    <el-dialog :title="form.id?'编辑客服':'新增客服'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="姓名：" prop="realName">
          <el-input v-model="form.realName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="头像：" prop="headImg">
          <div class="flexs">
            <imageUpload v-model="form.headImg" width="32" height="32" />
            <!-- <span class="hint hint1">限制上传1张<br />建议尺寸260x168像素以上</span> -->
          </div>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账号：" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="form.password" placeholder="请输入密码" />
        </el-form-item>
        <!-- <el-form-item label="工作状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch> {{form.state?'启用':'禁用'}}
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import custServiceStaffApi from '@/api/customer/custServiceStaff'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    id: null,
    realName: null,
    headImg: null,
    mobile: null,
    sex: null,
    userName: null,
    password: null,
    status: 10,
    workStatus: 20,
    isAutoReply: false,
    isNewMsgRemind: false
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      old: initFormBean(),
      formVisible: false,
      formRules: {
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        headImg: [{ required: true, message: '请上传', trigger: 'change' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.old = { ...row };
      for (const key in initFormBean()) {
        this.form[key] = this.old[key]
      }
      this.$set(this.form, 'password', '')
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            custServiceStaffApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            custServiceStaffApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }

        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
